import React from "react";
import Radium from "radium";
import {LIGHT_TEXT_COLOR} from "../../common/styles";
import {valueOrEmDash} from "../../common/displayUtils";
import DirectionType from "./DirectionType";
import PrettyDate from "../../common/components/PrettyDate";

const cellStyles = {
    padding: "5px",
    verticalAlign: "top",
    textAlign: "left"
};
const borderBottom = "1px solid rgba(0,0,0,0.07)";

const legPropertyLabel = {
    ...cellStyles,
    borderBottom,
    color: LIGHT_TEXT_COLOR,
    fontWeight: "normal",
    verticalAlign: "bottom"
};
const legProperty = {
    ...cellStyles,
    borderBottom
};

const recommendationPropertyLabel = {
    ...cellStyles,
    color: LIGHT_TEXT_COLOR,
    padding: "3px 5px",
    fontWeight: "normal",
    textAlign: "right",
};
const recommendationProperty = {
    ...cellStyles,
    padding: "3px 5px"
};

const CommunicationRecommendation = ({index, legs, recommendationProductionTimestamp, validityPeriod, commentary,conflictOfInterest}) => (
    <div style={{ paddingBottom: "1em" }}>
        <table>
            <tbody>
            <tr>
                <th style={[ legPropertyLabel, {width: 190} ]} colSpan="3">Recommendation {index + 1}</th>
                <th style={[ legPropertyLabel, {width:  50} ]}>Target Price</th>
                <th style={[ legPropertyLabel, {width:  50} ]}>Market Price</th>
                <th style={[ legPropertyLabel, {width: 105} ]}/>
            </tr>
            {legs.map(({legId, direction, instrumentData: {companyName, isin}, derivativeDescription, targetPrice, systemSuppliedMarketPrice, userSuppliedMarketPrice}, legIndex) => {
                const isLastRow = legIndex === legs.length - 1;
                const borderStyle = isLastRow ? {borderBottom: "none"} : {};

                return (
                    <tr key={legId}>
                        <td style={[ legProperty, borderStyle ]}>
                            <DirectionType direction={direction}/>
                        </td>
                        <td style={[ legProperty, borderStyle ]}>
                            <span className="x-recommendable-name">{companyName}</span><br/>
                            <span className="x-recommendable-isin"
                                  style={{color: LIGHT_TEXT_COLOR, fontSize: "80%"}}>{isin}</span>
                        </td>
                        <td style={[ legProperty, borderStyle ]}
                            className="x-derivative-description">{derivativeDescription}</td>
                        <td style={[ legProperty, borderStyle ]}
                            className="x-target-price">{valueOrEmDash(targetPrice)}</td>
                        <td style={[ legProperty, borderStyle ]}
                            className="x-market-price">{valueOrEmDash(systemSuppliedMarketPrice || userSuppliedMarketPrice)}</td>
                        <td style={[ legProperty, borderStyle ]}>
                            <a style={{ color: "#0078e7" }}
                               target="_blank"
                               className="x-disclosure-link"
                               href={`r/${legId}`}>view disclosures</a>
                        </td>
                    </tr>
                );
            })}
            </tbody>
        </table>

        <table>
            <tbody>
                <tr>
                    <th style={recommendationPropertyLabel}>Produced on</th>
                    <td style={recommendationProperty}><PrettyDate date={recommendationProductionTimestamp} timeOnSameLine={true}/></td>
                </tr>
                <tr>
                    <th style={recommendationPropertyLabel}>Validity Period</th>
                    <td style={recommendationProperty}>{validityPeriod}</td>
                </tr>
                <tr>
                    <th style={recommendationPropertyLabel}>Reasoning</th>
                    <td style={recommendationProperty}>{valueOrEmDash(commentary)}</td>
                </tr>
                <tr>
                    <th style={recommendationPropertyLabel}>Conflict of Interest</th>
                    <td style={recommendationProperty}>{conflictOfInterest}</td>
                </tr>
            </tbody>
        </table>
    </div>
);

CommunicationRecommendation.propTypes = {
    index: React.PropTypes.number,
    recommendationProductionTimestamp: React.PropTypes.string,
    validityPeriod: React.PropTypes.string,
    commentary: React.PropTypes.string,
    conflictOfInterest: React.PropTypes.string,
    legs: React.PropTypes.arrayOf(React.PropTypes.shape({
        legId: React.PropTypes.string,
        instrumentData: React.PropTypes.shape({
            companyName: React.PropTypes.string,
            isin: React.PropTypes.string
        }),
        direction: React.PropTypes.string,
        derivativeDescription: React.PropTypes.string,
        targetPrice: React.PropTypes.string,
        userSuppliedMarketPrice: React.PropTypes.string,
        systemSuppliedMarketPrice: React.PropTypes.string
    }))
};

export default Radium(CommunicationRecommendation);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/CommunicationRecommendation.js
 **/